import type { UntypedFormControl } from '@angular/forms';
import type { SitePageEntity } from '@common/types/site-page.type';
import type { MenuItem } from '@web/widgets/navigation/type/navigation-widget.type';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EButtonLinkType } from '@common/enums';

import {
    BUTTON_LINK_TYPE_PLACEHOLDER,
    LINK_TYPES,
    LINK_TYPE_NAME,
} from '@web/widgets/button/constants/button-widget.const';
import { WebBaseControlSettingsComponent } from '@web/widgets/common/abstract/web-base-control-settings.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpSwitchComponent } from '@ui/sp-switch';
import { NgFor, NgIf } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-navigation-settings',
    templateUrl: './navigation-settings.component.html',
    styleUrls: ['./navigation-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        WebSettingsModule,
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule,
        NgFor,
        NgIf,
        SpSwitchComponent,
        TranslateModule,
    ],
})
export class NavigationSettingsComponent extends WebBaseControlSettingsComponent<MenuItem> {
    @Input() public pages: SitePageEntity[] = [];

    public readonly EButtonLinkType = EButtonLinkType;
    public readonly LINK_TYPE_NAME = LINK_TYPE_NAME;
    public readonly LINK_TYPES = LINK_TYPES;
    public readonly BUTTON_LINK_TYPE_PLACEHOLDER = BUTTON_LINK_TYPE_PLACEHOLDER;

    protected initForm(): void {
        this.form = this.fb.group({
            name: null,
            linkUrl: null,
            linkType: null,
            isVisible: null,
            isTargetBlank: null,
            pageId: null,
            blockId: null,
            id: null,
            submenuList: null,
        });
    }

    protected setFormData(): void {
        this.form.patchValue(this.item, { emitEvent: false });
    }

    public get name(): UntypedFormControl {
        return this.form.get('name') as UntypedFormControl;
    }

    public setLinkData(linkUrl: string, name: string): void {
        this.linkUrl.setValue(linkUrl, { emitEvent: false });
        this.name.setValue(name);
    }

    public get linkType(): UntypedFormControl {
        return this.form.get('linkType') as UntypedFormControl;
    }

    public get linkUrl(): UntypedFormControl {
        return this.form.get('linkUrl') as UntypedFormControl;
    }

    public get isTargetBlank(): UntypedFormControl {
        return this.form.get('isTargetBlank') as UntypedFormControl;
    }

    public setLinkType(linkType: { name: string; type: EButtonLinkType }): void {
        this.linkType.setValue(linkType.type);
    }

    public setTargetBlank(value: boolean) {
        this.isTargetBlank.setValue(value);
    }
}
